import FormBuilder from '@/ui-kit/components/form/entities/FormBuilder';
import { requiredFormValidator } from '@/ui-kit/components/form/validators';
import { FormControlValidationStrategy } from '@/ui-kit/components/form/entities/enums';
import { LocationFormControlName } from '../enums';
import { LOCATION_DEFAULT_VALUES } from '../constants';

export class LocationFormBuilder extends FormBuilder {
  createCityControl(validators) {
    return this.createControl(LocationFormControlName.City, validators);
  }

  createProvinceControl(validators) {
    return this.createControl(LocationFormControlName.Province, validators);
  }

  createCommunityControl(validators) {
    return this.createControl(LocationFormControlName.Community, validators);
  }
}

export const createLocationFormGroup = (defaultValue = {}) => (
  new LocationFormBuilder({ ...LOCATION_DEFAULT_VALUES, ...defaultValue })
    .createCityControl([requiredFormValidator])
    .createProvinceControl([requiredFormValidator])
    .createCommunityControl()
    .build([FormControlValidationStrategy.Change, FormControlValidationStrategy.Blur])
);
